import { Account, Client, ID, TablesDB } from 'appwrite'

var endpoint = import.meta.env.VITE_APPWRITE_ENDPOINT
var projectId = import.meta.env.VITE_APPWRITE_PROJECT_ID
export var appwriteDatabaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID
export var appwriteRidesTableId = import.meta.env.VITE_APPWRITE_RIDES_TABLE_ID

if (!endpoint || !projectId) {
  throw new Error('Falta la configuración pública de Appwrite.')
}

export var appwriteClient = new Client()
  .setEndpoint(endpoint)
  .setProject(projectId)

export var appwriteAccount = new Account(appwriteClient)
export var appwriteTables = new TablesDB(appwriteClient)

export async function getAppwriteUser() {
  try {
    return await appwriteAccount.get()
  } catch (error) {
    await appwriteAccount.createAnonymousSession()
    return await appwriteAccount.get()
  }
}

export { ID }
